import { render, staticRenderFns } from "./ListHeaders.vue?vue&type=template&id=4f180120&"
import script from "./ListHeaders.vue?vue&type=script&lang=js&"
export * from "./ListHeaders.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports